import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import { fetchPaginatedReviews } from "../../services/axios/apiManager";
import { useAppContext } from "../../services/context";
import { useNavigate } from "react-router-dom";
import { handleErrors } from "../../services/dataManager";
import GameReviewsList from "./GameReviewsList";

const GameReviews = () => {
  const navigate = useNavigate();
  const { state } = useAppContext();
  const { permissions } = state;
  const [gameReviews, setGameReviews] = useState([]);
  const [pagination, setPagination] = useState({});
  const [granted, setGranted] = useState([]);

  const extractPermissions = () => {
    const perms = permissions.filter((f) => f.module === "Game_Reviews");
    if (perms) {
      setGranted(perms);
    }
  };

  const getData = async () => {
    const res = await fetchPaginatedReviews();
    if (res?.data?.success && res?.data?.data) {
      setGameReviews(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else handleErrors(res, navigate, "Providers List:");
  };
  useEffect(() => {
    extractPermissions();
    getData();
  }, []);
  return (
    <DashboardLayout>
      <div>
        <div className="col-12 mb-3">
          <div className="page-title-box d-sm-flex">
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <a>System Settings</a>
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "#8b8b8cbf" }}
                >
                  Game Reviews
                </li>
              </ol>
            </div>
          </div>
        </div>

        <GameReviewsList
          gameReviews={gameReviews}
          setGameReviews={setGameReviews}
          pagination={pagination}
          setPagination={setPagination}
          granted={granted}
        />
      </div>
    </DashboardLayout>
  );
};

export default GameReviews;
